module.exports = __webpack_public_path__ + "static/media/UK.defccf78.svg";